import React from "react";

export function LoadingPulse({ size = 20, color = "var(--green)" }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center",
      justifyContent: "center", gap: 4,
    }}>
      {[0, 1, 2].map(i => (
        <div key={i} style={{
          width: size * 0.25,
          height: size * 0.25,
          borderRadius: "50%",
          background: color,
          animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
          opacity: 0.7,
        }} />
      ))}
    </div>
  );
}
